import React, { useCallback, useMemo } from 'react';
import { Box, ButtonBase, Checkbox, InputBase, makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';
import DiaLog from '../../../components/Dialog';
import { AutoCompleteSelect } from '../../../components';
import { AirplaneIcon } from '../../../components/Icon';
import useTimeslotDialogStatus from '../hooks/useTimeslotDialogStatus';
import AutoCompleteInput from '../../../components/AutoCompleteInput';
import TimeInput from '../../Setting/components/Tele/Popup/Field/TimeInput';
import { TELEVISIT_CANCEL_TYPE, TELEVISIT_DELAY_TYPE, TELEVISIT_STATUS } from '../../../comm/constant';
import { ReactComponent as CancelledIcon } from '../../../static/images/Cancelled.svg';
import { i18n } from '../../../language';
import LongRemark from '../../../components/LongRemark';
import envelopeIcon from '../../../static/images/envelope.png';
import AdHocNotifacationListDialog from './AdHocNotificationList';

const useStyles = makeStyles((theme) => ({
  subTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    color: '#2e4469',
    marginBottom: '1.25rem',
  },
  textTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    marginBottom: '0.625rem',
  },
  textContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
    marginBottom: '1.875rem',
    display: 'flex',
    alignItems: 'center',
    gridGap: '0.5rem',
    wordBreak: 'break-word',
  },
  cardRoot: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    minHeight: '5.2rem',
    borderRadius: '15px',
    backgroundColor: '#f5faff',
    flexDirection: 'column',
    gridGap: '0.2rem',
    padding: '1rem 1.938rem',
  },
  cardTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  cardContent: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    color: '#538fff',
    display: 'flex',
    alignItems: 'center',
  },
  inputTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#666666',
    marginBottom: '0.938rem',
    display: 'flex',
    alignItems: 'center',
  },
  inputContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  notificationBtn: {
    width: '8.438rem',
    height: '6.288rem',
    borderRadius: '9px',
    backgroundColor: '#4d51b5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#ffffff',
    '&:disabled': {
      backgroundColor: '#c0c6cb !important',
      color: '#ffffff !important',
    },
  },
  zoomBtn: {
    width: '8.438rem',
    height: '6.288rem',
    borderRadius: '9px',
    backgroundColor: '#4d51b5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#ffffff',
    '&:disabled': {
      backgroundColor: '#c0c6cb !important',
      color: '#ffffff !important',
    },
  },
  airplaneIcon: {
    fontSize: '1.5rem',
    color: '#fff',
  },
  zoomTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    marginBottom: '0.625rem',
  },
  zoomContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#7d86a9',
  },
  input: {
    width: '21.938rem',
    height: '3.5rem',
    borderRadius: '10px',
    border: 'solid 1px #e4e7eb',
    padding: '0 1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    '&.MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#f5f5f5',
      color: '#2e4469',
    },
    '&.Mui-error': {
      borderColor: '#f44336',
    },
  },
  errorMsg: {
    color: 'rgb(244, 67, 54)',
    width: '100%',
    padding: '3px 0px 0px',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  star: {
    fontSize: '0.875rem',
    color: '#ff0000',
  },
  bigStart: {
    fontSize: '1.25rem',
    color: '#ff0000',
  },
  confirmContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  cancelInput: {
    borderRadius: '10px',
    border: 'solid 1px #e4e7eb',
    height: '3.5rem',
    width: '100%',
    paddingLeft: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  circle: {
    width: '0.75rem',
    height: '0.75rem',
    borderRadius: '50%',
    backgroundColor: '#bad2ff',
  },
  dashedCircle: {
    width: '0.75rem',
    height: '0.75rem',
    borderRadius: '50%',
    border: 'dashed 1px #cdcdcd',
  },
  unavailableIcon: {
    width: '0.75rem',
    height: '0.75rem',
    borderRadius: '50%',
    backgroundColor: '#e0e0e0',
  },
  verifyingIcon: {
    width: '0.75rem',
    height: '0.75rem',
    borderRadius: '50%',
    backgroundColor: '#decfff',
  },
  cancelledIcon: {
    fontSize: '0.75rem',
  },
  checkBox: {
    '&.MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '&.MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '&.Mui-checked': {
      color: '#28d2ab',
    },
    '&.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26) !important',
    },
    justifyContent: 'flex-start',
  },
  label: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  textContentText: {
    flex: '1 0',
  },
}));

const TimeslotDialog = ({ handleClose, info }) => {
  const classes = useStyles();
  const {
    moduleDisplay,
    dialogProps,
    visitField,
    data,
    updateData,
    itemLists,
    openCtrl,
    handleOpen,
    handleConfirm,
    handleCancel,
    handleSubmit,
    infoErrorMsg,
    resendSms,
    cancelBooking,
    cancelSelect,
    inputCancelReason,
    cancelInfo,
    handleLang,
    currentlyEffective,
    patientFilterOptions,
    handerHocSupport,
    delayInfo,
    inputDelayReason,
    delayReasonSelect,
    inputDelayTime,
    delayBooking,
    startMettingManually,
    detail,
    serviceSupportProps,
    serviceSupportUpdateBookingStatusInfo,
    serviceSupportUpdateBookingStatusSubmit,
    serviceSupportUpdateBookingStatusHandleStatusSelect,
    serviceSupportUpdateBookingStatusHandleInputCancelReason,
    isOutDate,
  } = useTimeslotDialogStatus({
    info,
    handleClose,
  });

  const StatusIcon = useMemo(() => {
    switch (data.status) {
      case i18n.t('TELEVISIT_SCHEDULED'):
      case i18n.t('TELEVISIT_CONFIRMED_SCHEDULED'):
      case i18n.t('TELEVISIT_ROBOT_STARTS_PROCESS_THE_BOOKING'):
      case i18n.t('TELEVISIT_VISIT_IN_PROGRESS'):
      case i18n.t('TELEVISIT_VISIT_COMPLETED'):
      case i18n.t('TELEVISIT_VISIT_COMPLETED_MANUALLY'):
        return <div className={classes.circle} />;
      case i18n.t('TELEVISIT_AVAILABLE'):
        return <div className={classes.dashedCircle} />;
      case i18n.t('TELEVISIT_UNAVAILABLE'):
        return <div className={classes.unavailableIcon} />;
      case i18n.t('TELEVISIT_VERIFYING'):
        return <div className={classes.verifyingIcon} />;
      case i18n.t('TELEVISIT_CANCELLED'):
        return <CancelledIcon className={classes.cancelledIcon} />;
      default:
        return <div />;
    }
  }, [data.status]);

  const longRemarkContent = useMemo(() => {
    let remark;
    if (data.cancelReasonType === '9') {
      remark = data?.otherCancelReasonMsg;
    } else {
      remark = _.find(itemLists?.cancelTypeRemark, (item) => item.value === data.cancelReasonType)?.text;
    }
    return remark;
  }, [itemLists?.cancelTypeRemark, data.cancelReasonType]);

  const longRemarkContentForRejected = useMemo(() => {
    let remark;
    switch (data.rejectReasonType) {
      case 1:
        return i18n.t('TELEVISIT_VISIT_REJECTED_REASON1');
      case 2:
        return i18n.t('TELEVISIT_VISIT_REJECTED_REASON2');
      case 3:
        return i18n.t('TELEVISIT_VISIT_REJECTED_REASON3');
      case 4:
        return i18n.t('TELEVISIT_VISIT_REJECTED_REASON4');
      default:
        return remark;
    }
  }, [data.rejectReasonType]);

  const checkServiceOptionsUpdateBookingStatusDisabled = useCallback((isOut, value, status) => {
    if (isOut && value !== 'UpdateBookingStatus') {
      return true;
    }
    if (value === 'UpdateBookingStatus') {
      if (_.indexOf([TELEVISIT_STATUS.ROBOT_START_PROCESSING_BOOKING, TELEVISIT_STATUS.INPROGRESS], status) === -1) {
        return true;
      }
    }
    return false;
  }, []);

  const getServiceSupportOptionDisabled = (option) => {
    if (checkServiceOptionsUpdateBookingStatusDisabled(isOutDate, option.value, detail.timeslotBookingStatusEnum)) {
      return true;
    }

    if (option.value === 'DelaySMS') {
      // send delay sms  , validate status
      if (_.indexOf([3, 8], detail.timeslotBookingStatusEnum) === -1) {
        return true;
      }
    }

    if (option.value === 'ManualMeeting') {
      // validate status
      if (_.indexOf([3, 4, 8, 9], detail.timeslotBookingStatusEnum) === -1) {
        return true;
      }

      // validate time
      let bufferTime = detail.bufferTime;
      if (!bufferTime) bufferTime = 0;
      let dateStr = moment(detail.timeslotDate).format('YYYY-MM-DD');
      let endDateStr = moment(detail.adHocEndDate ? detail.adHocEndDate : detail.timeslotDate).format('YYYY-MM-DD');
      let startTime = moment(`${dateStr} ${detail.startTime}`, 'YYYY-MM-DD HH:mm').subtract(bufferTime, 'm');
      let endTime = moment(`${endDateStr} ${detail.endTime}`, 'YYYY-MM-DD HH:mm');

      return !(startTime.isBefore(moment()) && endTime.isAfter(moment()));
    }

    return false;
  };

  const getDateTimeOptionDisabed = (options) => {
    return options.hocFlag === 1;
  };

  return (
    <>
      {openCtrl.timeslot && (
        <DiaLog
          open={true}
          width="76.813rem"
          p="2.375rem 1.938rem 1.875rem"
          handleClose={handleClose}
          handleCancel={handleCancel}
          handleConfirm={handleConfirm}
          dialogfootStyle={{
            paddingTop: '1rem',
            borderTop: 'solid 1px #e4e7eb',
            marginTop: '2rem',
            position: 'relative',
          }}
          cancelDisable={visitField.cancel?.disabled}
          disabled={visitField.confirm?.disabled}
          serviceSupportProps={{
            Visible: serviceSupportProps?.visible,
            disabled: serviceSupportProps?.disabled,
            itemList: itemLists.hocSupportList,
            handerChange: handerHocSupport,
            getOptionDisabled: getServiceSupportOptionDisabled,
            holder: i18n.t('TELEVISIT_POPUP_HOC_INFORMATION'),
          }}
          {...dialogProps}
        >
          <Box display="flex">
            <Box display="flex" flexDirection="column" pr="2.5rem" width="100%" borderRight="solid 1px #e4e7eb">
              {moduleDisplay.basicInfo && (
                <>
                  <div className={classes.subTitle}> {i18n.t('TELEVISIT_POPUP_BASIC_INFORMATION')}</div>
                  <Box display="flex">
                    <Box display="flex" flexDirection="column" flexBasis="50%">
                      <div className={classes.textTitle}>{i18n.t('TELEVISIT_POPUP_BOOKING_ID')}</div>
                      <div className={classes.textContent}>{data.bookingId}</div>
                    </Box>
                    <Box display="flex" flexDirection="column" flexBasis="50%">
                      <div className={classes.textTitle}>{i18n.t('TELEVISIT_POPUP_APPLICATION_TIME')}</div>
                      <div className={classes.textContent}>
                        {data.applicationTime ? moment(data.applicationTime, 'x').format('YYYY-MM-DD HH:mm') : ''}
                      </div>
                    </Box>
                  </Box>
                </>
              )}
              <Box display="flex">
                <Box display="flex" flexDirection="column" flexBasis="50%">
                  <div className={classes.textTitle}>{i18n.t('TELEVISIT_POPUP_ROBOT_IN_USE')}</div>
                  <div className={classes.textContent}>{data.robotInUse}</div>
                </Box>
                <Box display="flex" flexDirection="column" flexBasis="50%">
                  <div className={classes.textTitle}>{i18n.t('TELEVISIT_POPUP_STATUS')}</div>
                  <div className={classes.textContent}>
                    {StatusIcon}
                    <div className={classes.textContentText} style={{ display: 'flex', alignItems: 'center' }}>
                      <div dangerouslySetInnerHTML={{ __html: typeof data.status === 'string' ? data.status : '' }} />
                      {data.timeslotBookingStatusEnum === 7 && (
                        <LongRemark content={longRemarkContent} width="100%" minWidth="10rem" />
                      )}
                      {data.timeslotBookingStatusEnum === 6 && (
                        <LongRemark content={longRemarkContentForRejected} width="100%" minWidth="10rem" />
                      )}
                    </div>
                  </div>
                </Box>
              </Box>
              {moduleDisplay.selectPatient && (
                <VisitorFieldWrap title={i18n.t('TELEVISIT_POPUP_SELECT_PATIENT')} {...visitField.patient}>
                  <Box display="flex" flexDirection="column" mb="1.875rem">
                    <AutoCompleteInput
                      width="21.938rem"
                      value={data.patient}
                      itemList={itemLists.patientList}
                      onChange={updateData('patient', 'autocomplete')}
                      errorMsg={infoErrorMsg.patient}
                      error={Boolean(infoErrorMsg.patient)}
                      placeholder={i18n.t('TELEVISIT_POPUP_SELECT_PATIENT')}
                      filterOptions={patientFilterOptions}
                    />
                  </Box>
                </VisitorFieldWrap>
              )}
              <div className={classes.subTitle}>{i18n.t('TELEVISIT_POPUP_PATIENT_INFORMATION')}</div>
              <Box display="flex" flexDirection="column" gridGap="1.25rem">
                <div className={classes.cardRoot}>
                  <div className={classes.cardTitle}>{i18n.t('TELEVISIT_POPUP_LOCATION')}</div>
                  <div className={classes.cardContent}>{data.location}</div>
                </div>
                <div className={classes.cardRoot}>
                  <div className={classes.cardTitle}>{i18n.t('TELEVISIT_POPUP_PATIENT_NAME')}</div>
                  <div className={classes.cardContent}>{data.patientName}</div>
                </div>
                <div className={classes.cardRoot}>
                  <div className={classes.cardTitle}>{i18n.t('TELEVISIT_POPUP_PATIENT_ID')}</div>
                  <div className={classes.cardContent}>{data.patientId}</div>
                </div>
              </Box>
            </Box>
            <Box display="flex" flexDirection="column" pl="2.5rem" width="100%">
              <div className={classes.subTitle}>{i18n.t('TELEVISIT_POPUP_SELECTED_TIMESLOT')}</div>

              {moduleDisplay.baseDateTime && (
                <Box display="flex" justifyContent="space-between" gridGap="1.438rem" mb="1.875rem">
                  <Box display="flex" flexDirection="column">
                    <VisitorFieldWrap
                      className={classes.inputTitle}
                      title={i18n.t('TELEVISIT_POPUP_DATE')}
                      required={true}
                    />
                    {visitField?.date?.disabled ? (
                      <VisitorInput
                        className={classes.input}
                        value={moment(data.date, 'x').format('yyyy-MM-DD')}
                        {...visitField.date}
                      />
                    ) : (
                      <AutoCompleteSelect
                        width="21.938rem"
                        value={data.date}
                        itemList={itemLists.dateList}
                        {...visitField.date}
                        onChange={updateData('date', 'autocomplete')}
                      />
                    )}
                  </Box>
                  <Box display="flex" flexDirection="column">
                    <VisitorFieldWrap
                      className={classes.inputTitle}
                      title={i18n.t('TELEVISIT_POPUP_TIME')}
                      required={true}
                    />
                    {visitField?.time?.disabled ? (
                      <VisitorInput className={classes.input} value={data.time} {...visitField.time} />
                    ) : (
                      <AutoCompleteSelect
                        width="21.938rem"
                        value={data.time}
                        itemList={itemLists.timeList}
                        {...visitField.time}
                        onChange={updateData('time', 'autocomplete')}
                        getOptionDisabled={getDateTimeOptionDisabed}
                      />
                    )}
                  </Box>
                </Box>
              )}

              {moduleDisplay.urgentTimeBook && (
                <>
                  {moduleDisplay.durationAndBufferTime && (
                    <Box display="flex" justifyContent="space-between" gridGap="1.438rem" mb="1.875rem">
                      <Box display="flex" flexDirection="column">
                        <VisitorFieldWrap
                          className={classes.inputTitle}
                          title={i18n.t('TELEVISIT_POPUP_DURATION')}
                          required={true}
                        />

                        {visitField?.durationTime?.disabled ? (
                          <VisitorInput
                            className={classes.input}
                            value={data.durationTime}
                            {...visitField.durationTime}
                          />
                        ) : (
                          <AutoCompleteSelect
                            width="21.938rem"
                            value={data.durationTime}
                            itemList={itemLists.durationList}
                            {...visitField.durationTime}
                            onChange={updateData('durationTime', 'autocomplete')}
                          />
                        )}
                      </Box>

                      <Box display="flex" flexDirection="column">
                        <VisitorFieldWrap
                          className={classes.inputTitle}
                          title={i18n.t('TELEVISIT_SETTING_POPUP_BUFFER_TIME')}
                          remark={i18n.t('TELEVISIT_SETTING_POPUP_BUFFER_TIME_REMARK')}
                          required={true}
                        />

                        {visitField?.durationTime?.disabled ? (
                          <VisitorInput
                            className={classes.input}
                            value={data.bufferTime}
                            {...visitField.durationTime}
                          />
                        ) : (
                          <AutoCompleteSelect
                            width="21.938rem"
                            value={data.bufferTime}
                            errorMsg={infoErrorMsg?.bufferTime}
                            itemList={itemLists.bufferTimeList}
                            {...visitField.durationTime}
                            onChange={updateData('bufferTime', 'autocomplete')}
                          />
                        )}
                      </Box>
                    </Box>
                  )}
                  <Box display="flex" justifyContent="space-between" gridGap="1.438rem" mb="1.875rem">
                    <Box display="flex" flexDirection="column">
                      <VisitorFieldWrap
                        className={classes.inputTitle}
                        title={i18n.t('TELEVISIT_POPUP_STARTDATE')}
                        required={true}
                      />
                      {visitField?.hocStartDate?.disabled ? (
                        <VisitorInput
                          className={classes.input}
                          value={moment(data.date, 'x').format('yyyy-MM-DD')}
                          {...visitField.hocStartDate}
                        />
                      ) : (
                        <AutoCompleteSelect
                          width="21.938rem"
                          value={data.date}
                          itemList={itemLists.dateList}
                          {...visitField.hocStartDate}
                          onChange={updateData('date', 'autocomplete')}
                        />
                      )}
                    </Box>
                    <Box display="flex" flexDirection="column">
                      <VisitorFieldWrap
                        className={classes.inputTitle}
                        title={i18n.t('TELEVISIT_POPUP_STARTTIME')}
                        required={true}
                      />
                      {visitField?.hocStartTime?.disabled ? (
                        <VisitorInput className={classes.input} value={data.startTime} {...visitField.hocStartTime} />
                      ) : (
                        <TimeInput
                          width="21.938rem"
                          // onBlur={focusCheck('startTime', todayFlag)}
                          placeholder={i18n.t('TELEVISIT_SETTING_POPUP_START_TIME')}
                          value={data.startTime}
                          {...visitField.hocStartTime}
                          onChange={updateData('startTime', 'autocomplete')}
                          errorMsg={infoErrorMsg?.startTime}
                          itemList={itemLists.startTimeList}
                          freeSolo
                          clearOnblur
                          inputProps={{ value: data.startTime }}
                        />
                      )}
                    </Box>
                  </Box>

                  <Box display="flex" justifyContent="space-between" gridGap="1.438rem" mb="1.875rem">
                    <Box display="flex" flexDirection="column">
                      <VisitorFieldWrap
                        className={classes.inputTitle}
                        title={i18n.t('TELEVISIT_POPUP_ENDDATE')}
                        required={true}
                      />
                      {visitField?.hocEndDate?.disabled ? (
                        <VisitorInput
                          className={classes.input}
                          value={moment(data.endDate, 'x').format('yyyy-MM-DD')}
                          {...visitField.hocEndDate}
                        />
                      ) : (
                        <AutoCompleteSelect
                          width="21.938rem"
                          value={data.endDate}
                          itemList={itemLists.dateList}
                          {...visitField.hocEndDate}
                          onChange={updateData('endDate', 'autocomplete')}
                        />
                      )}
                    </Box>
                    <Box display="flex" flexDirection="column">
                      <VisitorFieldWrap
                        className={classes.inputTitle}
                        title={i18n.t('TELEVISIT_POPUP_ENDTIME')}
                        required={true}
                      />
                      {visitField?.hocEndTime?.disabled ? (
                        <VisitorInput className={classes.input} value={data.endTime} {...visitField.hocEndTime} />
                      ) : (
                        <TimeInput
                          width="21.938rem"
                          placeholder={i18n.t('TELEVISIT_SETTING_POPUP_END_TIME')}
                          value={data.endTime}
                          {...visitField.hocEndTime}
                          onChange={updateData('endTime', 'autocomplete')}
                          itemList={itemLists.endTimeList}
                          freeSolo
                        />
                      )}
                    </Box>
                  </Box>
                </>
              )}
              {moduleDisplay.televisitLink && (
                <>
                  <div className={classes.subTitle} style={{ margin: '0' }}>
                    {i18n.t('TELEVISIT_POPUP_TELEVISIT_INFORMATION')}
                  </div>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb="1.875rem" mt="1.25rem">
                    <Box display="flex" flexDirection="column">
                      <div className={classes.zoomTitle}> {i18n.t('TELEVISIT_POPUP_ZOOM_LINK')}</div>
                      <div className={classes.zoomTitle}> {data.zoomLink}</div>
                      <Box display="flex" gridGap="2rem">
                        <div className={classes.zoomContent}>{`${i18n.t('TELEVISIT_POPUP_MEETING_ID')} ${
                          data.meetingId
                        }`}</div>
                        <div className={classes.zoomContent}>{`${i18n.t('TELEVISIT_POPUP_PASSWORD')} ${
                          data.meetingPw
                        }`}</div>
                      </Box>
                    </Box>
                    <Box display="flex" justifyContent="flex-end">
                      <ButtonBase
                        className={classes.zoomBtn}
                        onClick={() => {
                          (async () => {
                            await resendSms();
                          })();
                        }}
                        disabled={visitField.zoom?.disabled}
                      >
                        <AirplaneIcon className={classes.airplaneIcon} />
                        <div dangerouslySetInnerHTML={{ __html: i18n.t('TELEVISIT_POPUP_RESEND_ZOOM_LINK') }} />
                      </ButtonBase>
                    </Box>
                  </Box>
                </>
              )}
              <div className={classes.subTitle}>{i18n.t('TELEVISIT_POPUP_VISITOR_INFORMATION')}</div>
              <Box display="flex" justifyContent="space-between" gridGap="1.438rem" mb="1.375rem">
                <Box display="flex" flexDirection="column">
                  <VisitorFieldWrap title={i18n.t('TELEVISIT_POPUP_VISITOR_FULL_NAME')} {...visitField.visitorFullName}>
                    <VisitorInput
                      className={classes.input}
                      value={data.visitorFullName}
                      {...visitField.visitorFullName}
                      onChange={updateData('visitorFullName', 'input')}
                      errorMsg={infoErrorMsg.visitorFullName}
                      placeholder={i18n.t('TELEVISIT_POPUP_VISITOR_FULL_NAME')}
                      inputProps={{ maxLength: 500 }}
                    />
                  </VisitorFieldWrap>
                </Box>
                <Box display="flex" flexDirection="column">
                  <VisitorFieldWrap title={i18n.t('TELEVISIT_POPUP_RELATIONSHIP')} {...visitField.relationship}>
                    <AutoCompleteSelect
                      width="21.938rem"
                      value={data.relationship}
                      itemList={itemLists.relationshipList}
                      {...visitField.relationship}
                      onChange={updateData('relationship', 'autocomplete')}
                      errorMsg={infoErrorMsg.relationship}
                      error={Boolean(infoErrorMsg.relationship)}
                      placeholder={i18n.t('TELEVISIT_POPUP_RELATIONSHIP')}
                    />
                  </VisitorFieldWrap>
                </Box>
              </Box>
              <Box display="flex" justifyContent="space-between" gridGap="1.438rem" mb="1.375rem">
                <Box display="flex" flexDirection="column">
                  <VisitorFieldWrap
                    title={i18n.t('TELEVISIT_POPUP_PHONE_NO')}
                    remark={i18n.t('TELEVISIT_POPUP_PHONE_NO_REMARK')}
                    {...visitField.contactPhoneNo}
                    required={true}
                  >
                    <VisitorInput
                      className={classes.input}
                      value={data.contactPhoneNo}
                      {...visitField.contactPhoneNo}
                      onChange={updateData('contactPhoneNo', 'input')}
                      errorMsg={infoErrorMsg.contactPhoneNo}
                      placeholder={i18n.t('TELEVISIT_POPUP_PHONE_NO')}
                    />
                  </VisitorFieldWrap>
                </Box>
                {itemLists.smsTypeList.length > 0 && (
                  <Box display="flex" flexDirection="column" width="100%">
                    <VisitorFieldWrap
                      title={i18n.t('TELEVISIT_NOTIFICATION_LANGUAGE')}
                      {...visitField.contactPhoneNo}
                      required={true}
                      style={{ marginBottom: '0' }}
                    >
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Box alignItems="center">
                          <Box width="14rem" alignItems="center" ml="-10px">
                            <Box display="flex" alignItems="center">
                              <Checkbox
                                className={classes.checkBox}
                                checked={data.langCode === itemLists.smsTypeList[1]?.value}
                                onChange={handleLang('CN')}
                                disabled={visitField.contactPhoneNo.disabled}
                              />
                              <label className={classes.label}>{itemLists.smsTypeList[1]?.text ?? ''}</label>
                            </Box>
                            <Box pl="37px" mt="-8px">
                              {currentlyEffective === itemLists.smsTypeList[1]?.value && (
                                <label className={classes.label}>({i18n.t('TELEVISIT_CURRENTLY_EFFECTIVE')})</label>
                              )}
                            </Box>
                          </Box>

                          <Box width="14rem" alignItems="center" ml="-10px">
                            <Checkbox
                              className={classes.checkBox}
                              checked={data.langCode === itemLists.smsTypeList[0]?.value}
                              onChange={handleLang('EN')}
                              disabled={visitField.contactPhoneNo.disabled}
                            />
                            <label className={classes.label}>{itemLists.smsTypeList[0]?.text ?? ''}</label>
                            <Box pl="37px" mt="-8px">
                              {currentlyEffective === itemLists.smsTypeList[0]?.value && (
                                <label className={classes.label}>({i18n.t('TELEVISIT_CURRENTLY_EFFECTIVE')})</label>
                              )}
                            </Box>
                          </Box>
                        </Box>

                        {data.bookingId && (
                          <Box display="flex" justifyContent="flex-end">
                            <ButtonBase className={classes.notificationBtn} onClick={handleOpen('notificationList')}>
                              <img
                                src={envelopeIcon}
                                alt="Notification History"
                                style={{ width: 22, height: 20, color: '#ffffff', marginBottom: 2.2 }}
                              />
                              <div dangerouslySetInnerHTML={{ __html: i18n.t('TELEVISIT_POPUP_NOTIFICATION_LIST') }} />
                            </ButtonBase>
                          </Box>
                        )}
                      </Box>
                    </VisitorFieldWrap>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </DiaLog>
      )}
      {openCtrl.unavailable && (
        <UnavailablePopup open={true} handleClose={handleOpen('timeslot')} handleSubmit={handleCancel} />
      )}
      {openCtrl.resume && <ResumePopup open={true} handleClose={handleOpen('timeslot')} handleSubmit={handleSubmit} />}
      {openCtrl.update && <UpdatePopup open={true} handleClose={handleOpen('timeslot')} handleSubmit={handleSubmit} />}
      {openCtrl.cancel && (
        <CancelBookingPopup
          open={true}
          handleClose={handleOpen('timeslot')}
          handleSubmit={cancelBooking}
          cancelSelect={cancelSelect}
          inputCancelReason={inputCancelReason}
          itemList={itemLists.cancelTypeList}
          cancelInfo={cancelInfo}
        />
      )}
      {openCtrl.delaySMS && (
        <DelaySMSPopup
          open={true}
          title={_.find(itemLists.hocSupportList, ['value', 'DelaySMS'])?.text}
          handleClose={handleOpen('timeslot')}
          handleSubmit={delayBooking}
          itemList={itemLists.delayReasonList}
          delayInfo={delayInfo}
          inputDelayReason={inputDelayReason}
          delayReasonSelect={delayReasonSelect}
          inputDelayTime={inputDelayTime}
        />
      )}
      {openCtrl.manualMeeting && (
        <ManualMeetingPopup
          title={_.find(itemLists.hocSupportList, ['value', 'ManualMeeting'])?.text}
          open={true}
          handleClose={handleOpen('timeslot')}
          handleSubmit={startMettingManually}
        />
      )}
      {openCtrl.notificationList && (
        <AdHocNotifacationListDialog open={true} handleClose={handleOpen('timeslot')} info={info} />
      )}
      {openCtrl.ServiceSupportUpdateBookingStatus && (
        <ServiceSupportUpdateBookingStatusPopup
          open={true}
          handleClose={handleOpen('timeslot')}
          handleSubmit={serviceSupportUpdateBookingStatusSubmit}
          typeSelect={serviceSupportUpdateBookingStatusHandleStatusSelect}
          inputCancelReason={serviceSupportUpdateBookingStatusHandleInputCancelReason}
          itemList={itemLists.serviceSupportUpdateBookingStatus}
          info={serviceSupportUpdateBookingStatusInfo}
        />
      )}
    </>
  );
};

function VisitorFieldWrap(props) {
  const { title, children, required, remark, style } = props;
  const classes = useStyles();
  return (
    <>
      <div className={classes.inputTitle} style={style}>
        {title}
        {required && <span className={classes.star}>*</span>}
        {remark && <LongRemark content={remark} width="100%" minWidth="10rem" />}
      </div>
      {children}
    </>
  );
}

const VisitorInput = ({ errorMsg, ...props }) => {
  const classes = useStyles();
  return (
    <>
      <InputBase {...props} error={Boolean(errorMsg)} />
      {errorMsg && <Typography className={classes.errorMsg}>{errorMsg}</Typography>}
    </>
  );
};

const UnavailablePopup = ({ handleSubmit, handleClose, open }) => {
  const classes = useStyles();
  return (
    <DiaLog
      open={open}
      title={i18n.t('TELEVISIT_POPUP_UNAVAILABLE_TIMESLOT')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_CONFIRM')}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleSubmit}
    >
      <div className={classes.confirmContent}>{i18n.t('TELEVISIT_POPUP_UNAVAILABLE_TIMESLOT_CONTENT')}</div>
    </DiaLog>
  );
};

const ResumePopup = ({ handleSubmit, handleClose, open }) => {
  const classes = useStyles();
  return (
    <DiaLog
      open={open}
      title={i18n.t('TELEVISIT_POPUP_RESUME_TIMESLOT')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_CONFIRM')}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleSubmit}
    >
      <div className={classes.confirmContent}>{i18n.t('TELEVISIT_POPUP_RESUME_TIMESLOT_CONTENT')}</div>
    </DiaLog>
  );
};

const UpdatePopup = ({ handleSubmit, handleClose, open }) => {
  const classes = useStyles();
  return (
    <DiaLog
      open={open}
      title={i18n.t('TELEVISIT_POPUP_UPDATE_BOOKING_DETAIL')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_CONFIRM')}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleSubmit}
    >
      <div className={classes.confirmContent}>{i18n.t('TELEVISIT_POPUP_UPDATE_BOOKING_DETAIL_CONTENT')}</div>
    </DiaLog>
  );
};

const CancelBookingPopup = ({
  handleSubmit,
  handleClose,
  open,
  cancelSelect,
  inputCancelReason,
  itemList,
  cancelInfo,
}) => {
  const classes = useStyles();

  return (
    <DiaLog
      open={open}
      title={i18n.t('TELEVISIT_POPUP_CANCEL_BOOKING_TITLE')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_CONFIRM')}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleSubmit}
      disabled={cancelInfo.cancelReasonType === String(TELEVISIT_CANCEL_TYPE.OTHER) && !cancelInfo.otherCancelReasonMsg}
    >
      <div
        className={classes.confirmContent}
        dangerouslySetInnerHTML={{ __html: i18n.t('TELEVISIT_POPUP_CANCEL_BOOKING_CONTENT1') }}
      />
      <br />
      <div className={classes.confirmContent}>{i18n.t('TELEVISIT_POPUP_CANCEL_BOOKING_CONTENT2')}</div>
      <Box display="flex" flexDirection="column" pt="1.875rem" gridRowGap="1.875rem">
        <AutoCompleteSelect itemList={itemList} onChange={cancelSelect} value={cancelInfo.cancelReasonType} />
        {cancelInfo.cancelReasonType === String(TELEVISIT_CANCEL_TYPE.OTHER) && (
          <InputBase
            className={classes.cancelInput}
            onChange={inputCancelReason}
            placeholder={i18n.t('TELEVISIT_POPUP_CANCEL_BOOKING_INPUT_REASON')}
            inputProps={{ maxLength: 255 }}
          />
        )}
      </Box>
    </DiaLog>
  );
};

const DelaySMSPopup = ({
  title,
  handleSubmit,
  handleClose,
  open,
  itemList,
  delayInfo,
  inputDelayReason,
  delayReasonSelect,
  inputDelayTime,
}) => {
  const classes = useStyles();

  return (
    <DiaLog
      open={open}
      title={title}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_CONFIRM')}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleSubmit}
      disabled={
        (delayInfo.delayReasonType === String(TELEVISIT_DELAY_TYPE.OTHER) && !delayInfo.otherDelayReasonMsg) ||
        delayInfo.errorMessage !== '' ||
        !delayInfo.delayReasonType
      }
    >
      <div className={classes.confirmContent}>{i18n.t('TELEVISIT_POPUP_DELAY_BOOKING_TIME')}</div>
      <Box display="flex" flexDirection="column" pt="0.875rem" pb="1rem">
        {/* <InputBase className={classes.input} onChange={inputDelayTime} value={delayInfo.delayTime} /> */}
        <VisitorInput
          className={classes.input}
          value={delayInfo.delayTime}
          onChange={inputDelayTime}
          errorMsg={delayInfo.errorMessage}
          inputProps={{ maxLength: 4 }}
        />
      </Box>
      <div className={classes.confirmContent}>{i18n.t('TELEVISIT_POPUP_DELAY_BOOKING_CONTENT')}</div>
      <Box display="flex" flexDirection="column" pt="0.875rem" gridRowGap="1.875rem">
        <AutoCompleteSelect
          itemList={itemList}
          onChange={delayReasonSelect}
          value={delayInfo.delayReasonType}
          placeholder={i18n.t('TELEVISIT_POPUP_DELAY_BOOKING_SELECT')}
        />
        {delayInfo.delayReasonType === String(TELEVISIT_DELAY_TYPE.OTHER) && (
          <InputBase
            className={classes.cancelInput}
            onChange={inputDelayReason}
            placeholder={i18n.t('TELEVISIT_POPUP_DELAY_BOOKING_INPUT_REASON')}
            inputProps={{ maxLength: 255 }}
            multiline={true}
          />
        )}
      </Box>
    </DiaLog>
  );
};

const ManualMeetingPopup = ({ title, handleSubmit, handleClose, open }) => {
  const classes = useStyles();
  return (
    <DiaLog
      open={open}
      title={title}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_CONFIRM')}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleSubmit}
      dialogfootStyle={{ marginTop: '1rem' }}
    >
      <div
        className={classes.confirmContent}
        dangerouslySetInnerHTML={{ __html: i18n.t('TELEVISIT_POPUP_MANUALMEETING_TIMESLOT_CONTENT') }}
      />
    </DiaLog>
  );
};

const ServiceSupportUpdateBookingStatusPopup = ({
  handleSubmit,
  handleClose,
  open,
  typeSelect,
  inputCancelReason,
  itemList,
  info,
}) => {
  const classes = useStyles();

  return (
    <DiaLog
      open={open}
      title={i18n.t('TELEVISIT_POPUP_SERVICE_SUPPORT_UPDATE_BOOKING_STATUS_TITLE')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_CONFIRM')}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleSubmit}
      disabled={(info.status === String(TELEVISIT_STATUS.CANCEL) && !info.otherCancelReasonMsg) || !info.status}
    >
      <div className={classes.confirmContent}>
        {i18n.t('TELEVISIT_POPUP_SERVICE_SUPPORT_UPDATE_BOOKING_STATUS_CONTENT')}
      </div>
      <Box display="flex" flexDirection="column" pt="1.875rem" gridRowGap="1.875rem">
        <AutoCompleteSelect
          itemList={itemList}
          onChange={typeSelect}
          value={info.status}
          placeholder={i18n.t('TELEVISIT_POPUP_SERVICE_SUPPORT_UPDATE_BOOKING_STATUS_PLACE_HOLDER')}
        />
        {info.status === String(TELEVISIT_STATUS.CANCEL) && (
          <InputBase
            className={classes.cancelInput}
            onChange={inputCancelReason}
            placeholder={i18n.t('TELEVISIT_POPUP_CANCEL_BOOKING_INPUT_REASON')}
            inputProps={{ maxLength: 255 }}
          />
        )}
      </Box>
    </DiaLog>
  );
};

export default TimeslotDialog;
